'use strict';

/**
 * Search suggestions in the header (snippets/header-search-field.liquid), from Shopify's Predictive Search API.
 * Combobox pattern: the input keeps focus, arrow keys move through the options (aria-activedescendant),
 * Enter opens the active option or submits the form, Esc closes. Products and collections are listed;
 * the last option leads to the full search. Results are built with textContent only (no HTML from the API).
 */
(function () {
  var MIN_CHARS = 2, DELAY = 200;

  function init(wrap) {
    var input = wrap.querySelector('input[type=search]');
    var panel = wrap.querySelector('[data-suggest-panel]');
    var status = wrap.querySelector('[data-suggest-status]');
    if (!input || !panel) return;
    var form = input.form;
    var d = wrap.dataset;
    var timer = null, ctl = null, options = [], active = -1, lastQuery = '';

    function money(cents) {
      var n = parseFloat(cents);
      if (isNaN(n)) return '';
      var f = d.moneyFormat || '{{amount}}';
      var m = f.match(/\{\{\s*(\w+)\s*\}\}/);
      var kind = m ? m[1] : 'amount';
      var dec = /no_decimals/.test(kind) ? 0 : 2;
      var comma = /comma_separator/.test(kind), space = /space_separator/.test(kind);
      var sep = comma ? '.' : space ? ' ' : /apostrophe/.test(kind) ? "'" : ',';
      var decSep = comma || (space && !/period/.test(kind)) ? ',' : '.';
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      var out = parts.join(decSep);
      if (dec) out = out.replace(new RegExp('\\' + decSep + '00$'), '');
      return f.replace(/\{\{\s*\w+\s*\}\}/, out).trim();
    }

    function sized(url, w) {
      try { var u = new URL(url, location.origin); u.searchParams.set('width', w); return u.toString(); } catch (e) { return url; }
    }

    // Titles are "Brand | Name" today and become "Name | Brand": drop the brand segment, it is shown as meta.
    function plainTitle(title, vendor) {
      var seg = String(title).split(' | ');
      if (seg.length > 1 && vendor) {
        var v = String(vendor).toLowerCase();
        if (seg[0].toLowerCase() === v) seg.shift();
        else if (seg[seg.length - 1].toLowerCase() === v) seg.pop();
      }
      return seg.join(' | ');
    }

    function el(tag, cls, text) {
      var e = document.createElement(tag);
      if (cls) e.className = cls;
      if (text != null) e.textContent = text;
      return e;
    }

    function close() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      active = -1;
    }

    function setActive(i) {
      if (options[active]) options[active].classList.remove('is-active');
      active = i;
      if (options[active]) {
        options[active].classList.add('is-active');
        input.setAttribute('aria-activedescendant', options[active].id);
        options[active].scrollIntoView({ block: 'nearest' });
      } else {
        input.removeAttribute('aria-activedescendant');
      }
    }

    function group(label, nodes) {
      var g = el('div', 'ps-group');
      g.setAttribute('role', 'group');
      g.setAttribute('aria-label', label);
      g.appendChild(el('div', 'ps-heading', label)).setAttribute('aria-hidden', 'true');
      nodes.forEach(function (n) { g.appendChild(n); });
      return g;
    }

    function option(href, cls) {
      var a = el('a', cls);
      a.href = href;
      a.setAttribute('role', 'option');
      a.id = input.id + '-opt-' + options.length;
      options.push(a);
      return a;
    }

    function render(q, res) {
      options = [];
      active = -1;
      panel.textContent = '';
      var products = (res.products || []), collections = (res.collections || []);
      if (!products.length && !collections.length) {
        panel.appendChild(el('p', 'ps-empty', (d.labelNone || '').replace('__Q__', q)));
        status.textContent = d.labelNone ? d.labelNone.replace('__Q__', q) : '';
      } else {
        if (products.length) {
          panel.appendChild(group(d.labelProducts, products.map(function (p) {
            var a = option(p.url, 'ps-item');
            var img = p.featured_image && p.featured_image.url || p.image;
            if (img) {
              var i = el('img', 'ps-img');
              i.src = sized(img, 96); i.alt = ''; i.width = 48; i.height = 48; i.loading = 'lazy';
              a.appendChild(i);
            } else a.appendChild(el('span', 'ps-img'));
            var t = el('span', 'ps-text');
            t.appendChild(el('span', 'ps-title', plainTitle(p.title, p.vendor)));
            var meta = [p.vendor, p.available === false ? d.labelSoldout : money(p.price)].filter(Boolean).join(' · ');
            if (meta) t.appendChild(el('span', 'ps-meta', meta));
            a.appendChild(t);
            return a;
          })));
        }
        if (collections.length) {
          panel.appendChild(group(d.labelCollections, collections.map(function (c) {
            var a = option(c.url, 'ps-item ps-item--text');
            a.appendChild(el('span', 'ps-title', c.title));
            return a;
          })));
        }
        status.textContent = (products.length + collections.length) + ' ' + (d.labelSuggestions || '');
      }
      var all = option(form.action + '?type=product&q=' + encodeURIComponent(q), 'ps-all');
      all.textContent = (d.labelAll || '').replace('__Q__', q);
      panel.appendChild(all);
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function search(q) {
      if (ctl) ctl.abort();
      ctl = window.AbortController ? new AbortController() : null;
      var url = d.url + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=5&resources[limit_scope]=each&resources[options][unavailable_products]=last';
      fetch(url, { headers: { Accept: 'application/json' }, signal: ctl ? ctl.signal : undefined })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (j) { if (input.value.trim() === q) { lastQuery = q; render(q, (j.resources && j.resources.results) || {}); } })
        .catch(function (e) { if (e && e.name !== 'AbortError') close(); });
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < MIN_CHARS) { if (ctl) ctl.abort(); lastQuery = ''; close(); return; }
      timer = setTimeout(function () { search(q); }, DELAY);
    });

    input.addEventListener('focus', function () {
      document.dispatchEvent(new CustomEvent('site-nav:close'));
      var q = input.value.trim();
      if (q.length >= MIN_CHARS && q === lastQuery && panel.children.length) {
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }
    });

    input.addEventListener('keydown', function (e) {
      if (panel.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1 >= options.length ? 0 : active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active <= 0 ? options.length - 1 : active - 1); }
      else if (e.key === 'Enter' && options[active]) { e.preventDefault(); location.href = options[active].href; }
      else if (e.key === 'Escape') { close(); }
    });

    wrap.addEventListener('suggest:close', close);
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
    wrap.addEventListener('focusout', function (e) { if (e.relatedTarget && !wrap.contains(e.relatedTarget)) close(); });
  }

  [].slice.call(document.querySelectorAll('[data-search-suggest]')).forEach(init);
})();
